import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import '../styles/Login.css';

function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess(false);
        setLoading(true);

        try {
            const { error } = await supabase.auth.resetPasswordForEmail(email, {
                redirectTo: window.location.origin + '/reset-password'
            });

            if (error) throw error;

            setSuccess(true);
        } catch (err) {
            setError(err.message || 'Erreur lors de l\'envoi du lien de réinitialisation');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-container">
            <div className="login-card">
                <div className="login-header">
                    <h1>ENOVADENT</h1>
                    <p>Réinitialisation du mot de passe</p>
                </div>

                {success ? (
                    <div className="login-form">
                        <div className="forgot-success-container">
                            <div className="forgot-success-icon">✉️</div>
                            <h2 className="forgot-success-title">Email envoyé !</h2>
                            <p className="forgot-success-text">
                                Un lien de réinitialisation a été envoyé à <strong>{email}</strong>.
                                Vérifiez votre boîte de réception (et vos spams) puis cliquez sur le lien pour définir un nouveau mot de passe.
                            </p>
                            <Link to="/login" className="submit-btn" style={{ display: 'block', textAlign: 'center', textDecoration: 'none', marginTop: '20px' }}>
                                Retour à la connexion
                            </Link>
                        </div>
                    </div>
                ) : (
                    <form onSubmit={handleSubmit} className="login-form">
                        <p className="forgot-instructions">
                            Entrez l'adresse email associée à votre compte. Nous vous enverrons un lien pour réinitialiser votre mot de passe.
                        </p>

                        <div className="form-group">
                            <label>Email</label>
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                placeholder="votre@email.com"
                                autoComplete="email"
                                autoFocus
                            />
                        </div>

                        {error && (
                            <div className="message error">
                                {error}
                            </div>
                        )}

                        <button type="submit" className="submit-btn" disabled={loading}>
                            {loading ? 'Envoi en cours...' : 'Envoyer le lien de réinitialisation'}
                        </button>
                    </form>
                )}

                <div className="login-footer">
                    <p>
                        Vous vous souvenez de votre mot de passe ?
                        <Link to="/login">Se connecter</Link>
                    </p>
                </div>
            </div>
        </div>
    );
}

export default ForgotPassword;
